import { LinkButton } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  reviewsCount?: string | null;
  writeLink?: string | null;
  reviewsLink?: string | null;
  onAllButtonClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onWriteButtonClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export function ReviewsSnippetFooter({
  className,
  reviewsCount,
  reviewsLink,
  writeLink,
  onAllButtonClick,
  onWriteButtonClick,
}: IProps) {
  const allButtonText = reviewsCount ? `Показать ${reviewsCount}` : 'Все отзывы';

  if (!reviewsLink && !writeLink) {
    return null;
  }

  return (
    <div className={cx(styles['wrapper'], className)}>
      {writeLink && (
        <LinkButton theme="fill_primary" size="XS" href={writeLink} onClick={onWriteButtonClick}>
          Написать отзыв
        </LinkButton>
      )}
      {reviewsLink && (
        <LinkButton theme="stroke_primary" size="XS" href={reviewsLink} onClick={onAllButtonClick}>
          {allButtonText}
        </LinkButton>
      )}
    </div>
  );
}
